/**
 *
 * api/auth
 *
 */

import store from 'store';
import { bludeltaRequest, BluDeltaResponse } from './network';

export const TOKEN_KEY = 'token';

type SubscribeToTokenCallback = (token: string | null) => void;

const subscribers: SubscribeToTokenCallback[] = [];

export function subscribeToToken(callback: SubscribeToTokenCallback): () => void {
  subscribers.push(callback);
  return () => {
    subscribers.splice(subscribers.indexOf(callback));
  };
}

function publishToken(token: string | null) {
  subscribers.forEach((subscriber) => subscriber(token));
}

export function setToken(token: string | null) {
  if (token) {
    store.set(TOKEN_KEY, token);
  } else {
    store.remove(TOKEN_KEY);
  }
  publishToken(token);
}

export function getToken() {
  return store.get(TOKEN_KEY) || null;
}

export interface LoginParams {
  Username: string;
  Password: string;
}

export interface LoginResponse extends BluDeltaResponse {
  AccessToken: string;
}

export function login(params: LoginParams) {
  const { Username, Password } = params;

  return bludeltaRequest<LoginResponse>(
    'POST',
    '/create/accesstoken',
    {},
    {
      'X-Username': Username,
      'X-Password': Password,
    },
  );
}
